import React from 'react';
import { Input } from '@fluentui/react-components';

export default function SearchInput({
  value,
  onChange,
  placeholder,
  ariaLabel,
  className,
  style,
}: {
  value: string;
  onChange: (val: string) => void;
  placeholder?: string;
  ariaLabel?: string;
  className?: string;
  style?: React.CSSProperties;
}) {
  return (
    <Input
      aria-label={ariaLabel}
      placeholder={placeholder}
      value={value}
      onChange={(_, data) => onChange(data.value)}
      className={className}
      style={style}
    />
  );
}
